export * from "./metadata";
export * from "./status";

export const MAX_NAME_CHAR_LIMIT = 256;

const ELLIPSIS = "...";

export function ensureNameIsValid(name: string) {
  return name.length > MAX_NAME_CHAR_LIMIT
    ? `${name.slice(0, MAX_NAME_CHAR_LIMIT - ELLIPSIS.length)}${ELLIPSIS}`
    : name;
}
